<template>
  <SharedStoreScheduleDialog ref="inner" merchant />
</template>

<script setup lang="ts">
import SharedStoreScheduleDialog from '@/views/o2o/store/StoreScheduleDialog.vue'

const inner = ref<InstanceType<typeof SharedStoreScheduleDialog>>()

defineExpose({
  open: (row: any) => inner.value?.open(row)
})
</script>
